import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { termsData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    position: 'relative',
    height: '200px',
    marginTop: 120,
    width: '100%',
    backgroundColor: '#F78181',
    backgroundAttachment: 'fixed',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Open Sans, sans-serif'
    }
  },
  centerTitle: {
    width: 400,
    height: 150,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  gridContainer: {
    // backgroundColor: 'pink',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 100
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '2rem',
    color: 'black',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '1.8rem',
    fontWeight: 700,
    color: 'black',
    marginBottom: 10
  },
  title1: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '0.9rem',
    fontWeight: 700,
    color: 'black',
    lineHeight: '50px',
    marginBottom: 10
  },
  list: {
    '& li': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '2rem',
      color: 'black',
      marginTop: 10,
      fontFamily: 'Open Sans, sans-serif'
    }
  }
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#f78181',
    border: '1px solid #f78181',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    alignItems: 'flex-start',
    verticalAlign: 'top',
    border: '1px solid #f78181',
    padding: 20
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  backgroundColor: theme.palette.action.hover
}));

const Cookies = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <h1>{t('PolitiquedeCookies')}</h1>
        </Box>
      </Grid>
      <Container maxWidth="md" style={{ marginBottom: 200 }}>
        <Grid container xs={12} className={classes.gridContainer}>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.text}>{t('Dlcds')}</Typography>
            <Typography className={classes.text}>{t('ldces')}</Typography>
            <Typography className={classes.text}>{t('cpvpdm')}</Typography>
            <Typography className={classes.text}>{t('nvidd')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('ecslbA')}</li>
              <li>{t('ecslbR')}</li>
              <li>{t('ecslbB')}</li>
            </ul>
            <Typography className={classes.text}>{t('vcnspd')}</Typography>
            <Typography className={classes.text}>{t('vcslddc')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>1. {t('qcqc')}</Typography>
            <Typography className={classes.text}>{t('uceup')}</Typography>
            <Typography className={classes.text}>{t('tdcrn')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('lcHTTP')}</li>
              <li>{t('lcFLASH')}</li>
              <li>{t('lrdcddlc')}</li>
              <li>{t('lpiowb')}</li>
              <li>{t('taigpu')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>2. {t('qslcdps')}</Typography>
            <Typography className={classes.text}>{t('ldcepsesp')}</Typography>
            <Typography className={classes.text}>{t('isa')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('alfds')}</li>
              <li>{t('mnaud')}</li>
              <li>{t('vadpc')}</li>
              <li>{t('pvex')}</li>
            </ul>
            <Typography className={classes.title1}>2.1. {t('lcsnalds')}</Typography>
            <Typography className={classes.text}>{t('ccalfn')}</Typography>
            <Typography className={classes.title1}>2.2. {t('lcpdmlenp')}</Typography>
            <Typography className={classes.text}>{t('ccnpd')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('mlpdc')}</li>
              <li>{t('ededmadg')}</li>
              <li>{t('dealp')}</li>
              <li>{t('nedsep')}</li>
              <li>{t('adnntdcc')}</li>
            </ul>
            <Typography className={classes.title1}>2.3. {t('lcpub')}</Typography>
            <Typography className={classes.text}>{t('ccpeuemep')}</Typography>
            <Typography className={classes.text}>{t('ccpde')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('mlaped')}</li>
              <li>{t('sdpsles')}</li>
              <li>{t('sdespup')}</li>
              <li>{t('cuppdp')}</li>
              <li>{t('ccevvsns')}</li>
            </ul>
            <Typography className={classes.title1}>2.4. {t('lcplpdc')}</Typography>
            <Typography className={classes.text}>{t('ccadfsqs')}</Typography>
            <Typography className={classes.text}>{t('iperde')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>
                <strong>{t('seducp')} </strong> {t('dcppve')}
              </li>
              <li>
                <strong>{t('cuppaucp')} </strong> {t('uppec')}
              </li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>3. {t('qsnosp')}</Typography>
            <Typography className={classes.text}>{t('npsurlws')} </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('google')}</li>
              <li>{t('googleads')}</li>
              <li>{t('linkedin')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>4. {t('cpvcdec')}</Typography>
            <Typography className={classes.title1}>4.1. {t('pavcman')}</Typography>
            <Typography className={classes.text}>{t('lvvnsite')}</Typography>
            <Typography className={classes.title1}>4.2. {t('paravoscslnu')}</Typography>
            <Typography className={classes.text}>{t('vnpepp')}</Typography>
            <Typography className={classes.text}>{t('nvrqlpes')}</Typography>
            <Typography className={classes.text}>{t('lcdcned')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('svldnep')}</li>
              <li>{t('sivcdd')}</li>
            </ul>
            <Typography className={classes.text}>{t('ppdslp')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>5. {t('cevd')}</Typography>
            <Typography className={classes.text}>{t('vdiddd')}</Typography>
            <Typography className={classes.text}>
              {t('ptddr')} <font color="blue">smileland@gmail.com.</font>
            </Typography>
          </Box>
        </Grid>
      </Container>
    </div>
  );
};

export default Cookies;
